import type CardClient from '@atlaskit/link-provider/client';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { useShortcutsSpaceNavigationQuery_quick } from '../src/useShortcuts.tsx';

export const ShortcutsSection: LoadableType<{
	isSpaceAdmin: boolean;
	spaceId: string | null;
	spaceKey: string;
	links: useShortcutsSpaceNavigationQuery_quick[];
	client?: CardClient | undefined;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShortcutsSection" */ '../src/ShortcutsSection.tsx'
			)
		).ShortcutsSection,
});
